import React from 'react'
import Toast from '../../../../components/Toast/Toast'
import ViewFormsRepresentadas from './ViewFormsRepresentadas'
import { FormContextProvider } from '../../../../context/formContext'

const FormRepresentationIFI = () => {
  return (
    <>
      <FormContextProvider>
        <Toast />
        <ViewFormsRepresentadas />
      </FormContextProvider>
    </>
  )
}

export default FormRepresentationIFI
